import { Group } from "./../groupReducer/groupTypes";
export enum MrgActionTypes {
  POST_EMAIL_FOR_LOGIN = "POST_EMAIL_FOR_LOGIN",
  GET_USER_INFOR = "GET_USER_INFOR",
  SET_LOADING = "SET_LOADING",
  LOG_OUT = "LOG_OUT",
}

export type MrgState = {
  email: string;
  name: string;
  loading: boolean;
};

export type PostEmailForLoginType = { validateToken: string };

export type PostCodeForLoginType = {
  token: string;
};

export type GetUesrInforType = {
  email: string;
  name: string;
  group: Group;
};

interface PostEmailForLogin {
  type: typeof MrgActionTypes.POST_EMAIL_FOR_LOGIN;
  payload: string;
}

interface SetLoading {
  type: typeof MrgActionTypes.SET_LOADING;
  payload: boolean;
}

interface GetUserInfor {
  type: typeof MrgActionTypes.GET_USER_INFOR;
  payload: Omit<GetUesrInforType, "group">;
}

interface LogOut {
  type: typeof MrgActionTypes.LOG_OUT;
}

export type MrgAction = PostEmailForLogin | SetLoading | GetUserInfor | LogOut;
